import { css } from '@styled/css';

export const magicLinkSetupWrapStyles = css({
  display: 'flex',
  justifyContent: 'center'
});

export const magicLinkSetupStyles = css({
  width: '100%',
  minWidth: '598px',
  background: 'var(--white)',
  padding: '0 82px',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
});

export const passwordFieldStyles = css({
  '& .amplify-field__error-message': {
    whiteSpace: 'pre-line !important'
  },
  '& .amplify-input.amplify-field-group__control': {
    borderRadius: '6px 0 0 6px !important'
  }
});
